// Import package from Soil plugin example.
import $ from "@modules/jquery";

$(function () {
  //
});

document.addEventListener(`DOMContentLoaded`, () => {
  const flexibleMenu = document.querySelector(
    ".ms_flexible-rearrangeable-elements-header"
  );
  if (flexibleMenu) {
    const menuItems = [
      ...flexibleMenu.querySelectorAll(".menu-item a[href^='#']"),
    ]
      .map((link) => {
        const id = link.getAttribute("href").slice(1);
        return document.getElementById(id);
      })
      .filter((el) => el !== null);

    const menuObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach((entry) => {
          let top = didThisIntersectionHappenAtTop(entry);

          // Page just loaded ... set active for the first intersecting section
          if (entry.time < 3000 && entry.isIntersecting) {
            const activeLink = flexibleMenu.querySelector(
              `a[href="#${entry.target.id}"]`
            );
            if (activeLink) {
              flexibleMenu.querySelectorAll(".menu-item").forEach((item) => {
                item.classList.remove("active");
              });
              activeLink.closest(".menu-item")?.classList.add("active");
            }
            return;
          } else if (entry.time < 3000) {
            return;
          }

          if (entry.isIntersecting) {
            flexibleMenu.querySelectorAll(".menu-item").forEach((item) => {
              item.classList.remove("active");
            });
            const activeLink = flexibleMenu.querySelector(
              `a[href="#${entry.target.id}"]`
            );
            if (activeLink) {
              activeLink.closest(".menu-item")?.classList.add("active");
            }
          } else if (!top && !entry.isIntersecting) {
            let indexOfThisSection = menuItems.findIndex(
              (el) => el === entry.target
            );
            if (indexOfThisSection > 0) {
              flexibleMenu.querySelectorAll(".menu-item").forEach((item) => {
                item.classList.remove("active");
              });
              const prevLink = flexibleMenu.querySelector(
                `a[href="#${menuItems[indexOfThisSection - 1].id}"]`
              );
              if (prevLink) {
                prevLink.closest(".menu-item")?.classList.add("active");
              }
            }
          }
        });
      },
      {
        root: null,
        rootMargin: "0px 0px -50% 0px",
        threshold: [1],
      }
    );

    menuItems.forEach((item) => {
      menuObserver.observe(item);
    });

    function didThisIntersectionHappenAtTop(entry) {
      return entry.rootBounds.bottom - entry.boundingClientRect.bottom >
        entry.rootBounds.bottom / 2
        ? true
        : false;
    }
  }

  document.querySelectorAll(".top-bar-flyout .menu-item").forEach((item) => {
    item.addEventListener("click", (e) => {
      item.dispatchEvent(
        new CustomEvent("toggle-mobile-menu", {
          detail: { open: false },
          bubbles: true,
        })
      );
    });
  });
});
